import { Label } from '../../Interface/Response/Interest/Label';

export enum LabelType {
    LabelSelected = 'labelSelected',
    LabelsLoaded = 'labelsLoaded',
}

export interface LabelSelectedAction {
    type: LabelType.LabelSelected;
    label: Label;
}

export interface LabelsLoadedAction {
    type: LabelType.LabelsLoaded;
    labels: Label[];
}

export const labelSelected = (label: Label): LabelSelectedAction => ({
    type: LabelType.LabelSelected,
    label,
});

export const labelsLoaded = (labels: Label[]): LabelsLoadedAction => ({
    type: LabelType.LabelsLoaded,
    labels,
});

export type LabelActionTypes = LabelSelectedAction | LabelsLoadedAction;
